import { Card, CardHeader } from 'components/common';
import {
  PopupDesc,
  PopupIconWrapper,
  PagePopupTitle,
} from 'components/Popup/ConfirmDialog/ConfirmDialog.styled';
import { PatientLayout } from 'containers/PatientLayout';
import { PropsWithChildren } from 'react';
import { FaUserClock } from 'react-icons/fa';
import { PageHelmet } from '../../../components/common/PageHelmet';

type MyAppointmentsCommonPageProps = PropsWithChildren<{
  title: string;
  description?: string;
}>;

export const MyAppointmentsCommonPage = ({
  title,
  description,
  children,
}: MyAppointmentsCommonPageProps) => {
  return (
    <PatientLayout graphics="patient">
      <PageHelmet title={title} />
      <Card>
        <CardHeader>
          <PopupIconWrapper inlineIcon>
            <FaUserClock />
          </PopupIconWrapper>
          <PagePopupTitle compact>{title}</PagePopupTitle>
          {description && <PopupDesc compact>{description}</PopupDesc>}
        </CardHeader>
        {children}
      </Card>
    </PatientLayout>
  );
};
